export default __webpack_public_path__ + "static/media/x.0bd78f3a.svg";